import { ContactForm } from '@shared/components/forms/ContactForm';

export default function ContactPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="flex justify-center">
        <ContactForm />
      </div>
    </div>
  );
}
